import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import type { StudentProfileV1 } from '@/types/studentprofile';
import { PP_BASE_URL } from '@/lib/env';

type SingleStudentResponse = {
  data?: StudentProfileV1;
};

export function useGetStudentById(studentId?: string, schoolYear?: string) {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key =
    studentId && baseUrl
      ? `${baseUrl}/students/${encodeURIComponent(studentId)}${schoolYear ? `?schoolYear=${encodeURIComponent(schoolYear)}` : ''}`
      : null;

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useSWR<SingleStudentResponse>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  return {
    swrKey: key,
    student: response?.data ?? null,
    isLoading,
    error,
    mutate,
  };
}
